import Vue from 'vue'

Vue.filter('title', function (value, replacer = '_') {
  if (!value) return ''
  value = value.toString()

  const arr = value.split(replacer)
  const capitalized_array = []
  arr.forEach((word) => {
    const capitalized = word.charAt(0).toUpperCase() + word.slice(1)
    capitalized_array.push(capitalized)
  })
  return capitalized_array.join(' ')
})

Vue.filter('thousand_seperator', function (value) {
  if (!value) return ''
  const number_value = Number(value);
  return number_value.toLocaleString();
})

Vue.filter('report_thousand_seperator', function (value, decimalPlaces) {
  if (!value) return '';
  const numberValue = Number(value);
  
  // Check if decimalPlaces is provided and is a valid number
  if (!isNaN(decimalPlaces) && decimalPlaces >= 0) {
    return numberValue.toLocaleString(undefined, { minimumFractionDigits: decimalPlaces, maximumFractionDigits: decimalPlaces });
  } else {
    return numberValue.toLocaleString();
  }
})

Vue.filter('four_decimals', function (value) {
  if (!value) return '0'
  return Number(value).toFixed(4);
})

Vue.filter('stock_status_format', function (value) {
  if (!value) return 'N/A'
  return value.replace(/[_-]/g, " ");
})

Vue.filter('remove_trailing_zeros', function (value) {
  return Number(value) === 0 ? '0' : Number(value).toString().replace(/(\.\d*?)0+$/, "$1").replace(/\.$/, "");
})

Vue.filter('format_quantity', function (value) {
  const quantityString = value.toString();
  if (quantityString.includes('.') && parseFloat(quantityString) !== Math.floor(parseFloat(quantityString))) {
    return parseFloat(quantityString).toFixed(1);
  }
  return parseInt(quantityString);
})

Vue.filter('crm_status_name_formatter', function(value) {
  return value !== 'Pending' ? value : 'New Enquiry'
})

Vue.filter('currency_code_formatter', function(value) {
  switch (value) {
    case 'GBP':
        return '£';
    case 'EUR':
        return '€';
    case 'USD':
        return '$';
    case 'AUD':
        return 'AU$'
    case 'DKK':
        return 'kr.'
    default:
        return ''
  }
})

Vue.filter('format_price', function (value, fx_rate = 1) {
  if (value == null || value === '') return '0.00'
  const rate = Number(fx_rate) || 1
  const amount = Number(value)
  if (isNaN(amount)) return '0.00'
  const total = amount * rate
  const sign = total < 0 ? -1 : 1
  const absTotal = Math.abs(total)
  return (sign * Number(Math.round(Number(absTotal + 'e2')) + 'e-2')).toFixed(2)
})

Vue.filter('month', function (val, showYear = true) {
  val = String(val)

  const regx = /\w+\s(\w+)\s\d+\s(\d+)./
  if (!showYear) {
    return regx.exec(val)[1]
  } else {
    return `${regx.exec(val)[1]} ${regx.exec(val)[2]}`
  }

})
